export const PUBLIC_PAGES = [
  '/chrome/*',
  '/error/*',
  '/login/*',
  '/loginstg/*',
  '/logout',
];

export const JUST_LOGIN_PAGES = [
  '/privacy',
];

export const SERVICE_PAGES = [
  '/guide/*',
];

export const ROLE_LIST = [
  { toPath: '/admin/*', role: 'sys_admin' },
];

export const ROLE_PAGES = ROLE_LIST.map(x => x.toPath);

export function includesString(routes, path) {
  const target = path.toLowerCase();
  return routes.find(route => {
    route = route.toLowerCase();
    return route.endsWith('*')
      ? target.startsWith(route.replace(/(\*|\/\*)/, ''))
      : (target === route);
  });
}
